import React from 'react';
import { useAuth } from '../hooks/useAuth';
import './NavigationDrawer.css';

const NavigationDrawer = ({ isOpen, onToggle, user, onLogout, currentView, onViewChange }) => {
  const { isAdmin } = useAuth();
  return (
    <>
      {/* Overlay */}
      <div className={`nav-overlay ${isOpen ? 'active' : ''}`} onClick={onToggle}></div>
      
      {/* Drawer */}
      <div className={`navigation-drawer ${isOpen ? 'active' : ''}`}>
        <div className="drawer-header">
          <div className="user-avatar">
            {user?.displayName?.charAt(0) || user?.email?.charAt(0) || 'U'}
          </div>
          <div className="user-details">
            <h3>{user?.displayName || 'User'}</h3>
            <p>{user?.email}</p>
          </div>
          <button className="close-drawer" onClick={onToggle}>
            ×
          </button>
        </div>
        
        <div className="nav-items">
          <button 
            className={`nav-item ${currentView === 'chat' ? 'active' : ''}`}
            onClick={() => {
              onViewChange('chat');
              onToggle();
            }}
          >
            <span className="nav-item-icon">💬</span>
            <span>Email Chat</span>
          </button>
          <button 
            className={`nav-item ${currentView === 'analytics' ? 'active' : ''}`}
            onClick={() => {
              onViewChange('analytics');
              onToggle();
            }}
          >
            <span className="nav-item-icon">📊</span>
            <span>Analytics</span>
          </button>
          {isAdmin && (
            <button 
              className={`nav-item ${currentView === 'admin' ? 'active' : ''}`}
              onClick={() => {
                onViewChange('admin');
                onToggle();
              }}
            >
              <span className="nav-item-icon">⚙️</span>
              <span>Admin Dashboard</span>
            </button>
          )}
          <button className="nav-item">
            <span className="nav-item-icon">⚙️</span>
            <span>Settings</span>
          </button>
          <button className="nav-item">
            <span className="nav-item-icon">❓</span>
            <span>Help</span>
          </button>
        </div>
        
        <div className="drawer-footer">
          <button className="logout-btn" onClick={onLogout}>
            <span className="nav-item-icon">🚪</span>
            <span>Sign Out</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NavigationDrawer;
